import { render, staticRenderFns } from "./ParentCategoryDetail.vue?vue&type=template&id=b30b0092&scoped=true&"
import script from "./ParentCategoryDetail.vue?vue&type=script&lang=js&"
export * from "./ParentCategoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30b0092",
  null
  
)

export default component.exports